/**
 * @description 查询微码应用能力
 * @param {string} appId 应用id
 * @param {'innerapp'|'isv'} type innerapp-自建应用，isv-第三方应用
 */
export const fetchWeAppInfo = (appId, type) => {
  return fetch(`/wecode/service/${type}/wecode/ability/${appId}`, {
    method: "GET"
  });
};

/**
 * @description 删除微码应用能力
 * @param {string} appId 应用id
 * @param {'innerapp'|'isv'} type innerapp-自建应用，isv-第三方应用
 */
export const deleteWeAbility = (appId, type) => {
  return fetch(`/wecode/service/${type}/wecode/ability/${appId}`, {
    method: "DELETE"
  });
};

/**
 * @description 配置微码应用能力，暂时只传中文地址
 * @param {object} param
 * @param {string} param.pcUrlCn
 * @param {string} param.manageUrlCn
 * @param {string} param.appId
 * @param {'innerapp'|'isv'} type innerapp-自建应用，isv-第三方应用
 */
export const updateWeAppInfo = (param, type) => {
  const fetchUrl = {
    innerapp: "innerapp",
    isv: "isv/app"
  };
  return fetch(`/wecode/service/${fetchUrl[type]}/wecode/ability/${param.appId}`, {
    method: "PUT",
    body: JSON.stringify(param)
  });
};
